/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { PreloadedQuery } from 'react-relay';
import { fg } from '@atlassian/jira-feature-gating';
// eslint-disable-next-line jira/import-whitelist
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
// eslint-disable-next-line jira/import-whitelist -- Unclear how to change the config whilst we transition to flat config
import QUERY from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/common/ui/virtual-agent/__generated__/VirtualAgentSidebarQuery$parameters';
import type { VirtualAgentSidebarQuery } from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/common/ui/virtual-agent/__generated__/VirtualAgentSidebarQuery.graphql';
import type { RouteResource } from '@atlassian/react-resource-router';

export const virtualAgentOnboardingResource: RouteResource<
	PreloadedQuery<VirtualAgentSidebarQuery, Record<string, unknown>>
> = createRelayResource<VirtualAgentSidebarQuery>({
	type: 'SERVICEDESK_VIRTUAL_AGENT_ONBOARDING',
	isBrowserOnly: true,
	getQuery: ({ match }, { tenantContext }) => ({
		parameters: QUERY,
		variables: {
			cloudId: tenantContext.cloudId,
			key: match.params.projectKey || '',
			checkForAiEnabledFF: fg('require_ai_enabled_for_jsm_virtual_agent'),
		},
	}),
});
